import { useMemo } from 'react'

import { JobFolderAccordion } from 'components/JobFolderAccordion'
import { useDashboardsQueries } from 'hooks-queries/dashboards'
import { formatJobForFolderList } from 'utils/jobUtils'

import './styles.scss'

import { GET_JOB_FOLDERS_LOG } from './const'

/**
 * @param {Object} props
 * @param {JobWithFolders[]} props.jobs
 * @param {string} props.selectedJobId
 * @param {number} [props.foldersLimit]
 * @param {(jobId: string, folderId: string | null, shouldCollapse?: boolean) => void} props.onSelectFolder
 */
export const JobFolderSelectorList = props => {
  const { jobs, selectedJobId, foldersLimit, onSelectFolder } = props

  return (
    <div className="JobFolderSelectorList-wrapper">
      {jobs.map(job => (
        <JobFolderWithFetch
          key={job.id + job.title}
          job={job}
          isActive={selectedJobId === job.id}
          foldersLimit={foldersLimit}
          onCollapse={() => onSelectFolder(job.id, null, true)}
          onSelectFolder={folder => onSelectFolder(job.id, folder.id)}
        />
      ))}
    </div>
  )
}

function JobFolderWithFetch({ job, isActive, foldersLimit, onCollapse, onSelectFolder }) {
  const { data, loading } = useDashboardsQueries({
    queryName: 'getJobFolders',
    queryVariables: {
      jobId: job.id,
      pagination: { take: foldersLimit ?? 40 },
    },
    options: {
      skip: !isActive,
    },
    errorLog: GET_JOB_FOLDERS_LOG,
  })

  const folders = useMemo(
    () =>
      data?.getWorkspaceJob?.foldersPaginated?.data?.map(
        folder => formatJobForFolderList({ ...job, foldersPaginated: { data: [folder] } }).folders[0]
      ) ?? [],
    [data, job]
  )

  return (
    <>
      <JobFolderAccordion
        job={job}
        folders={folders}
        isActive={isActive}
        foldersLimit={foldersLimit}
        isLoading={loading}
        onCollapse={onCollapse}
        onSelectFolder={onSelectFolder}
      />
    </>
  )
}
